/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useDebounceEffect } from '../form/useDebounceEffect';
import useStore from '../../store';

const Q_COUNT = gql`
	query getNpCount {
		getNpCount
	}
`;

function NoteOfPresentationBadge() {
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const [loadNpCount, { data }] = useLazyQuery(Q_COUNT);

	useDebounceEffect(loadNpCount, 200, [countUnreadNotifications]);

	const count = useMemo(() => parseInt(data?.getNpCount?.unreadCount), [data]);

	return (
		<>
			{count > 0 && (
				<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
					{count}
				</Badge>
			)}
		</>
	);
}

export default NoteOfPresentationBadge;
